import { useMemo } from 'react';

import Permissions from '@/common/permissions';
import { useHasAccess } from '@/modules/core';
import { IFileTypeDtoFileTypeEnum } from '@/types';

import useAllowedFileTypes from './useAllowedFileTypes';

const useAllowProcessAdjustmentFile = (fileType?: IFileTypeDtoFileTypeEnum | string) => {
  const { isAdjustmentAllowed } = useAllowedFileTypes();
  const hasPermissionToUploadAdjustment = useHasAccess([
    {
      permission: Permissions.LOAD_BALANCE_ADJUSTMENT_FILE,
    },
  ]);
  const allowAdjustmentProcess = useMemo(() => {
    if (fileType === IFileTypeDtoFileTypeEnum.BALANCE_ADJUSTMENT) {
      if (hasPermissionToUploadAdjustment && isAdjustmentAllowed) {
        return true;
      }
      return false;
    }
    return true;
  }, [fileType, hasPermissionToUploadAdjustment, isAdjustmentAllowed]);
  return allowAdjustmentProcess;
};

export default useAllowProcessAdjustmentFile;
